
(() => {
  if (window.LotCollectionInfiniteScrollLoaded) return;
  window.LotCollectionInfiniteScrollLoaded = true;

  const observer = new IntersectionObserver(async (entries) => {
    for (const entry of entries) {
      if (!entry.isIntersecting) continue;

      const trigger = entry.target;
      const wrapper = trigger.previousElementSibling;
      const url = trigger.dataset.nextUrl;

      if (!url || !wrapper || trigger.dataset.loading === 'true') continue;

      trigger.dataset.loading = 'true';
      observer.unobserve(trigger);

      try {
        const response = await fetch(url, {
          credentials: 'same-origin'
        });

        if (!response.ok) throw new Error('Could not load products');

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const nextGrid = doc.querySelector('.ProductListWrapper .ProductList');
        const currentGrid = wrapper.querySelector('.ProductList');

        if (!nextGrid || !currentGrid) throw new Error('Product grid missing');

        Array.from(nextGrid.children).forEach((product) => {
          currentGrid.appendChild(product);
        });

        const nextTrigger = doc.querySelector('.CollectionInfiniteScroll');
        const nextUrl = nextTrigger?.dataset.nextUrl || '';

        if (nextUrl) {
          trigger.dataset.nextUrl = nextUrl;
          trigger.dataset.loading = 'false';
          observer.observe(trigger);
        } else {
          trigger.remove();
        }
      } catch (error) {
        console.error('Infinite scroll:', error);
        trigger.dataset.loading = 'false';
        observer.observe(trigger);
      }
    }
  }, { rootMargin: '500px' });

  function initialize() {
    document.querySelectorAll('.CollectionInfiniteScroll').forEach((trigger) => {
      if (trigger.dataset.initialized === 'true') return;
      trigger.dataset.initialized = 'true';
      observer.observe(trigger);
    });
  }

  document.addEventListener('DOMContentLoaded', initialize);
  document.addEventListener('shopify:section:load', initialize);
})();
